import React from "react";

function Timeline() {
  return (
    <div className="timeline-root">
      <h3>Our Journey of Love ❤️</h3>
      <section className="time-line">
        <div className="container" style={{ "--dly": "1s" }}>
          <div className="text-content">
            <h2> The First Gift</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum modi esse in consequatur repellendus laboriosam! ❤️</p>
          </div>
        </div>
        <div className="container" style={{ "--dly": "2s" }}>
          <div className="text-content">
            <h2>💍 The Proposal</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic, aperiam odio! Dolores, error! Placeat, facere. ❤️</p>
          </div>
        </div>
        <div className="container" style={{ "--dly": "3s" }}>
          <div className="text-content">
            <h2> The Most Unforgettable Moment</h2>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ex numquam sunt necessitatibus dolorum eius placeat. 💕</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Timeline;
